<template>
    <nav aria-label="...">
        <ul class="pagination justify-content-center">
            <li :class="{'page-item': true, 'disabled': currentPage <= 1}">
                <a class="page-link" href="" tabindex="-1" @click.prevent="prev">Page précédente</a>
            </li>
            <li v-for="i in range" :class="{'page-item': true, 'active': currentPage === i}">
                <template v-if="currentPage !== i">
                    <a class="page-link" @click.prevent="gotoPage(i)">
                        {{ i }}
                        <span v-if="currentPage === i" class="sr-only"> (current)</span>
                    </a>
                </template>
                <template v-else>
                    <div class="page-link">
                        {{ i }}
                        <span v-if="currentPage === i" class="sr-only"> (current)</span>
                    </div>
                </template>
            </li>
            <li :class="{'page-item': true, 'disabled': currentPage >= maxPage}">
                <a class="page-link" href="" @click.prevent="next">Page suivante</a>
            </li>
        </ul>
    </nav>
</template>

<script>
import {mapGetters} from 'vuex';
import store from '../store';

export default {
  name: 'ponroy-pagination',
  store,
  props: {
    value: {
        type: Number
    },
    radius: {
        type: Number,
        default: 1
    },
    count: {
        type: Number,
        default: 0
    },
    numberToShow: {
        type: Number,
        default: 12
    }
  },
  data() {
    return {
        currentPage: this.value
    };
  },
  watch: {
    value(value) {
        this.currentPage = value;
    },
    currentPage(value){
        this.$emit('input', value);
    }
  },
  computed: {
    range() {
        let range = [];

        let start = this.currentPage - this.radius;

        if(start < 1) {
            start = 1;
        }

        let end = this.currentPage + this.radius;

        if(end > this.maxPage) {
            end = this.maxPage;
        }

        for(let i = start; i < end + 1; i++) {
            range.push(i);
        }
        return range;
    },
    maxPage() {
        return Math.ceil(this.count / this.numberToShow);
    }
  },
  methods: {
    prev() {
        if(this.currentPage > 1){
            this.currentPage--;
            this.scrollTop();
        }
    },
    next() {
        if(this.currentPage < this.maxPage){
            this.currentPage++;
            this.scrollTop();
        }
    },
    gotoPage(page) {
        this.currentPage = page;
        this.scrollTop();
    },
    scrollTop() {
      document.documentElement.scrollTop = 0
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/Pagination.vue